type Listener = (dirty: boolean) => void

let dirty = false
const listeners = new Set<Listener>()

export const setGhostEchoDirty = (nextDirty: boolean): void => {
  if (dirty === nextDirty) return
  dirty = nextDirty
  for (const listener of listeners) listener(dirty)
}

export const isGhostEchoDirty = (): boolean => dirty

export const subscribeGhostEchoDirty = (listener: Listener): (() => void) => {
  listeners.add(listener)
  listener(dirty)
  return () => {
    listeners.delete(listener)
  }
}
